import { useState } from 'react'
import { useIntl } from 'react-intl'

export default function useBenefits() {
  const intl = useIntl()

  const [benefitsForCompanies] = useState([
    {
      id: 1,
      title:
        intl.messages['smb_acquisition_home.benefits.company.benefit_1.title'],
      description:
        intl.messages[
          'smb_acquisition_home.benefits.company.benefit_1.subtitle'
        ],
    },
    {
      id: 2,
      title:
        intl.messages['smb_acquisition_home.benefits.company.benefit_2.title'],
      description:
        intl.messages[
          'smb_acquisition_home.benefits.company.benefit_2.subtitle'
        ],
    },
    {
      id: 3,
      title:
        intl.messages['smb_acquisition_home.benefits.company.benefit_3.title'],
      description:
        intl.messages[
          'smb_acquisition_home.benefits.company.benefit_3.subtitle'
        ],
    },
  ])

  const [benefitsForEmployees] = useState([
    {
      id: 1,
      title:
        intl.messages['smb_acquisition_home.benefits.employee.benefit_1.title'],
      description:
        intl.messages[
          'smb_acquisition_home.benefits.employee.benefit_1.subtitle'
        ],
    },
    {
      id: 2,
      title:
        intl.messages['smb_acquisition_home.benefits.employee.benefit_2.title'],
      description:
        intl.messages[
          'smb_acquisition_home.benefits.employee.benefit_2.subtitle'
        ],
    },
    {
      id: 3,
      title:
        intl.messages['smb_acquisition_home.benefits.employee.benefit_3.title'],
      description:
        intl.messages[
          'smb_acquisition_home.benefits.employee.benefit_3.subtitle'
        ],
    },
  ])

  return {
    benefitsForCompanies,
    benefitsForEmployees,
  }
}
